import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { contactUs } from "../reducers/contact";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const dispatch = useDispatch();
  const { isLoading, successMessage, errorMessage } = useSelector((state) => state.contact);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(contactUs(formData));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id="contact" className="contact animate">
      <h2>Contact Us</h2>
      <p>We'd love to hear from you! Fill out the form below, and we'll get back to you as soon as possible.</p>
      <div className="contact-form">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="cta-button" disabled={isLoading}>
            {isLoading ? "Sending..." : "Send"}
          </button>
        </form>
        {successMessage && <p className="success-message">{successMessage}</p>}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </section>
  );
};

export default Contact;
